import { format } from "date-fns";

import { AllFormsFilter } from "./components/AllFormsFilters";

export const getFiltersForSearchService = (filters: AllFormsFilter, searchTerm?: string) => {
	const finalFilters = {};

	if (filters?.subject) {
		finalFilters["subject_eq"] = filters.subject.id;
	}

	if (filters.authors) {
		finalFilters["authors_in"] = filters.authors.map((author) => author.id);
	}

	if (filters.signers) {
		finalFilters["signers_in"] = filters.signers.map((signer) => signer.id);
	}

	if (filters?.status && filters.status.length > 0) {
		finalFilters["status_eq"] = filters.status;
	}

	if (filters?.authorsDueDateAfter) {
		finalFilters["authors_due_date_gt"] = format(filters.authorsDueDateAfter, "yyyy-MM-dd'T'HH:mm:ss");
	}

	if (filters?.authorsDueDateBefore) {
		finalFilters["authors_due_date_lt"] = format(filters.authorsDueDateBefore, "yyyy-MM-dd'T'HH:mm:ss");
	}

	if (filters?.signersDueDateAfter) {
		finalFilters["signers_due_date_gt"] = format(filters.signersDueDateAfter, "yyyy-MM-dd'T'HH:mm:ss");
	}

	if (filters?.signersDueDateBefore) {
		finalFilters["signers_due_date_lt"] = format(filters.signersDueDateBefore, "yyyy-MM-dd'T'HH:mm:ss");
	}

	if (filters?.completedDateAfter) {
		finalFilters["complete_date_gt"] = format(filters.completedDateAfter, "yyyy-MM-dd'T'HH:mm:ss");
	}

	if (filters?.completedDateBefore) {
		finalFilters["complete_date_lt"] = format(filters.completedDateBefore, "yyyy-MM-dd'T'HH:mm:ss");
	}

	if (filters?.form) {
		finalFilters["form_name_eq"] = filters.form.name;
	} else if (searchTerm) {
		finalFilters["form_name_re"] = searchTerm;
	}

	if (filters?.showOnlyExternalForms && filters.showOnlyExternalForms.length > 0) {
		finalFilters["external_eq"] = true;
	}

	if (filters?.showOnlyFormsWithUnassignedAuthors && filters.showOnlyFormsWithUnassignedAuthors.length > 0) {
		finalFilters["is_assigned_eq"] = false;
	}

	if (!filters?.includeDeactivatedSubjects || filters.includeDeactivatedSubjects.length === 0) {
		finalFilters["subject_deactivated_eq"] = false;
	}

	finalFilters["show_redacted_eq"] = filters?.redacted || false;

	return finalFilters;
};
